import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import SimbaRestaurant from './pages/SimbaRestaurant';
import SimbaTaxi from './pages/SimbaTaxi';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/simba-restaurant' component={SimbaRestaurant} />
        <Route exact path='/simba-taxi' component={SimbaTaxi} />
        <Route exact path='/privacy-policy' component={PrivacyPolicy} />
        <Route exact path='/terms-and-conditions' component={TermsConditions} />
        <Route exact path='/' component={Home} />
      </Switch>
    </Router>
  );
}

export default App;
